import React from "react";

// React 19 hoists <title>/<meta>/<link> rendered anywhere into <head>.
export const Seo = ({ title, description, path, ogImage }) => {
  const fullTitle = title ? `${title} — Health and More` : "Health and More";
  const url = `https://healthandmore.net${path || ""}`;
  const img = ogImage || "https://healthandmore.net/og-default.png";
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </>
  );
};

export default Seo;
